import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import React, { Component } from 'react';

import { getFechaIn_dd_mm_yy, returnDataCatalogV2 } from "../../controller/utils";


export default class MyDocumentRelacion extends Component {
    constructor(props) {
        super(props);
    }

    styles = StyleSheet.create({
        page: {
            flexDirection: 'row',
            backgroundColor: '#fff'
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1
        },
        backgroundImg: {
            position: 'absolute',
            left: 0,
            top: 0
        },
        centerImage: {
            alignItems: "center",
            flexGrow: 1
        },
        image: {
            padding: 0,
            width: '100%',
            position: 'absolute',
            left: 0
        },
        imagePosition: (left, right, top, size, size2) => {
            return {
                left: left ? `${left}` : 'auto',
                right: right ? `${right}` : 'auto',
                top: top ? `${top}` : 'auto', // 175
                width: size ? size : '50%',
                height: size2 ? size2 : '50%',
                position: 'absolute'
            };
        },
        fontText: (left, right, top, size) => {
            return {
                left: left ? `${left}` : 'auto',
                right: right ? `${right}` : 'auto',
                top: top ? `${top}` : 'auto', // 175
                fontSize: size ? size : 9,
                position: 'absolute',
                fontWeight: 'bold'
            };
        },

    });
    fontSize(cadena) {
        return cadena.length > 60 ? 5
            : cadena.length > 50 ? 6 : cadena.length > 40 ? 7 : 8;
    };
    fontSizeM(cadena) {
        return cadena.length > 60 ? 4 : cadena.length > 50 ? 5
            : cadena.length > 40 ? 6 : cadena.length > 30 ? 7 : 8;
    };

    fontSizeA(cadena) {
        return cadena.length > 55 ? 2 : cadena.length > 41 ? 3 : cadena.length > 32 ? 4 : cadena.length > 25 ? 5
            : cadena.length > 21 ? 6 : cadena.length > 19 ? 7 : 8;
    };

    fontSizeCortar(cadena) {
        return cadena.length > 23 ? cadena.slice(0, 23) : cadena;
    };



    render() {
        const { data, direccion } = this.props;
        const registro = data.step0.datosinicio;
        const contacto = data.step1.datospersonaladmin ? data.step1.datospersonaladmin : [];
        const empleador = data.step2.datosempleador;

        let posTypeCompany = 25;
        if (empleador.companyClass === "2")
            posTypeCompany = 78;
        if (empleador.companyClass === "3")
            posTypeCompany = 131;

        let activityEconomic = [];
        if (registro.economicActivityStart)
            activityEconomic = registro.economicActivityStart.split(" ");

        let fecha = getFechaIn_dd_mm_yy()
        //primera position personal contact

        const dir_fecha = `${direccion}, ${fecha}`
        return (
            <React.Fragment>
                <Document>
                    <Page size="A4" style={this.styles.page} >
                        <View style={this.styles.section} >
                            <Image style={this.styles.image} src="/relacion_trabajadores.jpg" />
                            <Text style={this.styles.fontText(78, false, 77, 9)}>{dir_fecha}</Text>
                            {/* <Text style={this.styles.fontText(410, false, 20, 9)}>{empleador.processNumber ?" empleador.processNumber" : ""}</Text> */}
                            <Text style={this.styles.fontText(90, false, 244, 8)}>{registro.employerNameStart.toUpperCase()}</Text>
                            <Text style={registro.typeIdCompanyStart === 'NI' ? this.styles.fontText(199, false, 254, 10) : registro.typeIdCompanyStart === 'CC' ? this.styles.fontText(252, false, 254, 10) : this.styles.fontText(252, false, 254, 10)}>xx</Text>
                            <Text style={this.styles.fontText(312, false, 254, 9)}>{registro.checkNumberStart}</Text>

                            {
                                contacto.length > 0 && contacto.map((post, i) => {
                                    if (i < 4) {
                                        const postuRow = 350 + (11 * i);

                                        let id = `${post.typeIdStaff ? post.typeIdStaff : ""} ${post.numberIdStaff ? post.numberIdStaff : ""}`;
                                        let name = `${post.firstNameStaff ? post.firstNameStaff.toUpperCase() : ""} ${post.secondNameStaff ? post.secondNameStaff.toUpperCase() : ""} ${post.firstLastnameStaff ? post.firstLastnameStaff.toUpperCase() : ""} ${post.secondLastnameStaff ? post.secondLastnameStaff.toUpperCase() : ""}`

                                        return (
                                            <React.Fragment>
                                                <Text style={this.styles.fontText(77, false, postuRow, 7)}>{(i + 1)}</Text>
                                                <Text style={this.styles.fontText(108, false, postuRow, 7)}>{name}</Text>
                                                <Text style={this.styles.fontText(290, false, postuRow, 7)}>{id}</Text>
                                            </React.Fragment>
                                        )

                                    }
                                })
                            }

                        </View>

                    </Page>
                </Document>
            </React.Fragment>
        );
    }
}